
/* injects from baggage-loader */

import Helpers from "../helperFunctions";
import { firstHalf, secondHalf, activeSequences, periodsBySports, mapEventNames } from "../../constants/asianMarketNamesFilter";
import { hasVideo } from "../sport/videoFilter";
import React, { useContext, useCallback, useMemo } from "react";
import Config from "../../config/main";
import { t } from "../../helpers/translator";
import { MarketContext } from "../../terminal/components/gameListAsian/marketContext";
import { Select } from "../../components/styledComponents/select";
import { generateMarketKey } from '../markets';
import _ from "lodash";

export const handleGameMarketsRestSubscriptionData = (data, selectedSportAlias, moreMarkets) => {
    data.marketGroups = [];
    data.market = Helpers.objectToArray(data.market, null, (market) => {
        if (!market) return null;

        if (market.display_sub_key && activeSequences.includes(market.display_sub_key)) {
            if (activeSequences.includes(market.display_sub_key) && !firstHalf.includes(market.market_type) && !secondHalf.includes(market.market_type) && !market.sequence) {
                market.type = market.display_sub_key;
            } else if (market.display_sub_key && market.sequence) {
                market.type = market.sequence === 0 ? market.display_sub_key + market.sequence + 1 : market.display_sub_key + market.sequence;
            } else {
                market.type = firstHalf.includes(market.market_type) ? "1Half" : secondHalf.includes(market.market_type) && "2Half" || "";
            }
        } else if (market.display_sub_key === "PERIOD") {
            if (!firstHalf.includes(market.market_type) && !secondHalf.includes(market.market_type)) {
                if (market.sequence === 0 && (market.market_type.match(/\d+/) && market.market_type.match(/\d+/)[0] > 1)) {
                    let sequenceFromMarketType = market.market_type.match(/\d+/)[0];
                    market.type = sequenceFromMarketType + (periodsBySports[selectedSportAlias] || "");
                } else {
                    market.type = market.sequence === 0 ? market.sequence + 1 + (periodsBySports[selectedSportAlias] || "") : market.sequence + (periodsBySports[selectedSportAlias] || "");
                }
                //old
                // market.type = market.sequence === 0 ? market.sequence + 1 + (periodsBySports[selectedSportAlias] || "") : market.sequence + (periodsBySports[selectedSportAlias] || "");
            } else {
                market.type = firstHalf.includes(market.market_type) ? "1Half" : "2Half";
            }
        }
        if (market.type !== undefined) {
            data.marketGroups.push(market.type);
        }

        if (market.event && market.type) {
            Helpers.objectToArray(market.event).map((event) => {
                let key = event && event.show_type || event.type_1 || event.type || event.name;
                switch (market.display_key) {
                    case "WINNER":
                        key = key === 'Home' ? 'P1' : (key === 'Away' ? 'P2' : key);
                        break;
                    default:
                        key = key === 'W1' ? 'P1' : (key === 'W2' ? 'P2' : key);
                        break;
                }
                event.type = mapEventNames[key.replace(/ /g, '')] || key.replace(/ /g, '');
                market.event[event.id] = event;
            });
        }
    }).filter(Boolean);
    data.marketGroups = data.marketGroups.filter((val, index, array) => array.indexOf(val) === index);
    data.groupedMarkets = {};
    data.marketGroups.map((group) => {
        data.market.map((market) => {
            const marketKey = generateMarketKey(group, market);

            // let marketBase = market.base === 0 ? 0 : market.base ? market.base : ''; //todo MIQO JAN

            if (!moreMarkets) {
                if (market.type === group && !data.groupedMarkets[marketKey]) {
                    data.groupedMarkets[generateMarketKey(group, market)] = market;
                }
            } else {
                if (market.type === group) {
                    data.groupedMarkets[marketKey] = data.groupedMarkets[marketKey] || [];
                    data.groupedMarkets[marketKey].push(market);
                }
            }
        });
    });

    return data;
};

export const getMarketType = (sportAlias, displayKey) => {
    return Config.asianMarketTypeFilter[displayKey][sportAlias] && { "@in": Config.asianMarketTypeFilter[displayKey][sportAlias] };
};

export const handleGameUpdate2 = (game, sport) => {
    game.marketGroups = [];
    game.groupedMarkets = {};
    game.alias = sport.alias;

    game.market = Helpers.objectToArray(game.market, null, (market) => {
        if (market.display_sub_key && activeSequences.includes(market.display_sub_key)) {
            if (activeSequences.includes(market.display_sub_key) && !firstHalf.includes(market.market_type) && !secondHalf.includes(market.market_type) && !market.sequence) {
                market.type = market.display_sub_key;
            } else if (market.display_sub_key && market.sequence) {
                market.type = market.sequence === 0 ? market.display_sub_key + market.sequence + 1 : market.display_sub_key + market.sequence;
            } else {
                market.type = firstHalf.includes(market.market_type) ? "1Half" : secondHalf.includes(market.market_type) && "2Half" || "";
            }
        } else if (market.display_sub_key === "PERIOD") {
            if (!firstHalf.includes(market.market_type) && !secondHalf.includes(market.market_type)) {
                if (market.sequence === 0 && (market.market_type.match(/\d+/) && market.market_type.match(/\d+/)[0] > 1)) {
                    let sequenceFromMarketType = market.market_type.match(/\d+/)[0];
                    market.type = sequenceFromMarketType + (periodsBySports[sport.alias] || "");
                } else {
                    market.type = market.sequence === 0 ? market.sequence + 1 + (periodsBySports[sport.alias] || "") : market.sequence + (periodsBySports[sport.alias] || "");
                }
                //old
                // market.type = market.sequence === 0 ? market.sequence + 1 + (periodsBySports[sport.alias] || "") : market.sequence + (periodsBySports[sport.alias] || "");
            } else {
                market.type = firstHalf.includes(market.market_type) ? "1Half" : "2Half";
            }
        }
        if (market.event && market.type) {
            Helpers.objectToArray(market.event).map((event) => {
                let key = event.show_type || event.type_1 || event.type || event.name;
                switch (market.display_key) {
                    case "WINNER":
                        key = key === 'Home' ? 'P1' : (key === 'Away' ? 'P2' : key);
                        break;
                    default:
                        key = key === 'W1' ? 'P1' : (key === 'W2' ? 'P2' : key);
                        break;
                }
                event.type = mapEventNames[key.replace(/ /g, '')] || key.replace(/ /g, '');
                market.event[event.id] = event;
            });
        }
    });

    game.market.sort((a, b) => a.order - b.order);

    game.market.forEach((market) => {
        if (market.type !== undefined) {
            game.marketGroups.push(market.type);
        }
    })

    game.marketGroups = game.marketGroups.filter((val, index, array) => array.indexOf(val) === index).sort((a, b) => {
        if (isFinite(a) && isFinite(b)) {
            return a - b;
        }

        switch ("MATCH") {
            case a:
                return -1;
            case b:
                return 1;
            default:
                return 0;
        }
    });
    game.marketGroups.map((group) => {
        game.market.map((market) => {
            const marketKey = generateMarketKey(group, market);

            if (market.type === group && !game.groupedMarkets[marketKey])
                game.groupedMarkets[marketKey] = market;
        });
    });
    game.hasVideo = hasVideo(game);
    return game;
};

export const handleFavoriteGameListSubscriptionData = (data) => {
    let competitions = [],
        games = {},
        sportData = Helpers.cloneDeep(data);
    let sortedByOrderSportData = Object.values(sportData.sport).sort((a, b) => a.order - b.order);
    sortedByOrderSportData && sortedByOrderSportData.map((sport) => {
        Helpers.objectToArray(sport.region, null, (region) => {
            competitions.push(...Helpers.objectToArray(region && region.competition, null, (competition) => {
                competition.regionName = region.name;
                competition.regionAlias = region.alias;
                competition.regionId = region.id;
                competition.sport = { alias: sport.alias, name: sport.name };
                competition.game = Helpers.objectToArray(competition.game, null, (game) => {
                    game.sportName = sport.name;
                    game.regionName = competition.regionName;
                    game.regionId = competition.regionId;
                    game.order = sport.order;
                    game.regionAlias = competition.regionAlias;
                    game.competitionOrder = competition.order;
                    game.marketGroups = [];
                    game.groupedMarkets = {};
                    game.competitionId = competition.id;
                    game.competitionName = competition.name;
                    game.competitionAlias = competition.alias;
                    game.sport = competition.sport;
                }).sort(Helpers.byStartTsSortingFunc);
                competition.gamesCount = competition.game.length;
            }));
        });
    });

    competitions.sort(Helpers.byOrderSortingFunc).map(competition => {
        competition.game.map(game => {
            games[game.id] = game && handleGameUpdate2(game, competition.sport);
        });
    });
    // console.log('******************handleFavoriteGameListSubscriptionData********************');
    // console.log(games);
    // console.log('******************************************');
    return games;
};

export const handleGameListAsianSubscriptionData = (data, selectedSport) => {
    let sport = Object.keys(data.sport).length && Helpers.firstElement(data),
        regions = sport && Helpers.firstElement(sport) && Helpers.firstElement(sport).region,
        competition = regions && (() => {
            return Object.keys(regions).reduce((collected, regionId) => {
                let region = regions[regionId],
                    competitions = region.competition;

                Object.values(competitions).forEach((current) => {
                    Object.values(current.game).forEach((game) => {
                        game.regionOrder = region.order;
                        game.regionAlias = region.alias;
                        game.regionId = region.id;
                        game.regionName = region.name;
                        game.competitionName = current.name;
                        game.competitionId = current.id;
                        game.competitionOrder = current.order;
                    });
                });

                return {
                    ...collected,
                    ...competitions
                };
            }, {});
        })(),
        games = (competition && Object.keys(competition).length > 1)
            ? Object.values(competition).reduce((collected, current) => {
                return collected.concat(Helpers.objectToArray(current.game));
            }, [])
            : Helpers.firstElement(competition) && Helpers.firstElement(competition).game && Helpers.objectToArray(Helpers.firstElement(competition).game);

    return games && games.map((game) => {
        return handleGameUpdate2(game, selectedSport);
    }).filter(game => Boolean(game)).reduce((current, game) => {
        current[game.id] = game;
        return current;
    }, {});
};

export function DrawMarketHeader({ gameType, sportAlias, oneSelectView, uniqueDisplayKeys }) {
    const allTypesArr = getAsianMarketTypes(gameType, sportAlias);

    const marketTypesArray = useMemo(() => {
        if (uniqueDisplayKeys?.length) return _.uniqBy(allTypesArr, item => item[0].display_key)
            .filter(item => uniqueDisplayKeys.includes(item[0].display_key));

        return allTypesArr;
    }, [allTypesArr]);

    if (oneSelectView) return <MarketTitle market={marketTypesArray.reduce((acc, item) => [...acc, ...item], [])} index={0} />

    return <>
        {marketTypesArray.map((market, index) => {
            return <MarketTitle market={market} index={index} key={index} />;
        })}
    </>;
}

function MarketTitle({ market, index }) {
    const [state, dispatch] = useContext(MarketContext);
    const marketIndex = state[index];
    const handlerChange = useCallback((name, value) => dispatch({
        type: "CHANGE",
        payload: {
            index, value: value
        }
    }), [index]);
    const { side = [] } = market[marketIndex];
    const str = side.length === 2 && Config.enableAsianMarketSideView  ? 's-v' : 't-v';

    return <>
        {side.map((sideItem, indexSideItem) => {
            if (indexSideItem === 0) {
                return (
                    <div className={`market-t-v ${str}`} key={indexSideItem}>
                        <div className={`a-market-name-t ${str}`} >
                            <Select
                                data={market.map((item, marketIndex) => ({ value: marketIndex, text: t(item.title) }))}
                                name='market'
                                className='open-other-p'
                                optionsClassname={'market-dropdown'}
                                value={marketIndex}
                                onChange={handlerChange}
                            />
                        </div>
                        {Config.enableAsianMarketSideView && <i>{t(sideItem)}</i>}
                    </div>
                );
            }
            return Config.enableAsianMarketSideView && (
                <div className="market-t-v" key={indexSideItem}>
                    <i>{t(sideItem)}</i>
                </div>
            );
        })}
    </>;
}

const getMarketHeaderItem = (market, sportAlias) => {
    let ret = [];
    switch (market) {
        case "TOTALS":
            ret.push((
                <div className="market-t-v">
                    <p className="a-market-name-t s-v">{t(market)}</p>
                    <i>{t("OVER")}</i>
                </div>
            ));
            ret.push((
                <div className="market-t-v">
                    <i>{t("UNDER")}</i>
                </div>
            ));
            break;
        case "ODD/EVEN":
            ret.push((
                <div className="market-t-v">
                    <p className="a-market-name-t s-v">{t(market)}</p>
                    <i>{t("ODD")}</i>
                </div>
            ));
            ret.push((<div className="market-t-v"><i>{t("EVEN")}</i></div>));
            break;
        case "BOTHTEAMTOSCORE":
            ret.push((
                <div className="market-t-v">
                    <p className="a-market-name-t s-v">{t(market)}</p>
                    <i>{t("Yes")}</i>
                </div>
            ));
            ret.push((<div className="market-t-v"><i>{t("No")}</i></div>));
            break;
        case "WINNER":
            switch (sportAlias.toLowerCase()) {
                case 'tennis':
                case 'basketball':
                case 'volleyball':
                case 'baseball':
                case 'tableTennis':
                case 'americanFootball':
                case 'mma':
                    ret.push((
                        <div className="market-t-v">
                            <p className="a-market-name-t s-v">{t(market)}</p>
                            <i>1</i>
                        </div>
                    ));
                    ret.push((
                        <div className="market-t-v"><i>2</i></div>
                    ));
                    break;
                default:
                    ret.push((
                        <div className="market-t-v">
                            <p className="a-market-name-t t-v">{t(market)}</p>
                            <i>1</i>
                        </div>
                    ));
                    ret.push((
                        <div className="market-t-v"><i>X</i></div>
                    ));
                    ret.push((
                        <div className="market-t-v"><i>2</i></div>
                    ));
                    break;
            }
            break;
        case "HANDICAP":
            ret.push((
                <div className="market-t-v">
                    <p className="a-market-name-t s-v">{t(market)}</p>
                    <i>1</i>
                </div>));
            ret.push((<div className="market-t-v"><i>2</i></div>));
            break;
        case "NEXTGOALTOSCORE":
            if (Config.terminal.asianViewTwoImportantMarkets) { /// it will remove when current circus have no event in NEXTGOALTOSCORE market
                ret.push((
                    <div className="market-t-v">
                        <p className="a-market-name-t t-v">{t("Next Goal")}</p>
                        <i>1</i>
                    </div>));
            } else {
                ret.push((
                    <div className="market-t-v">
                        <p className="a-market-name-t s-v">{t("Next Goal")}</p>
                        <i>1</i>
                    </div>));
            }
            ret.push((<div className="market-t-v"><i>2</i></div>));
            if (Config.terminal.asianViewTwoImportantMarkets) { /// it will remove when current circus have no event in NEXTGOALTOSCORE market
                ret.push((<div className="market-t-v"><i>{t(`No`)}</i></div>));
            }
            break;
    }
    return ret;
};

export const getAsianMarketTypes = (gameType, sportAlias) => {
    const gameTypeA = gameType === 'live' ? gameType : 'prematch';
    const { default: { [gameTypeA]: defaultMarket = {} } = {} } = Config.asianViewMarket;

    if (Array.isArray(sportAlias)) {
        const markets = sportAlias.reduce((acc, item) => {
            const { [item]: { [gameTypeA]: market = defaultMarket } = {} } = Config.asianViewMarket;
            return [...acc, ...market];
        }, []);

        return markets.length ? markets : defaultMarket;
    } else {
        const { [sportAlias]: { [gameTypeA]: market = defaultMarket } = {} } = Config.asianViewMarket;
        return market;
    }
};